import {
  FiArchive,
  FiChevronDown,
  FiChevronUp,
  FiClock,
  FiGrid,
  FiList,
  FiSettings,
  FiSidebar,
} from "react-icons/fi";
import { boardPublicPath } from "@/config/browserBoard";
import { DesktopRefreshLabel } from "@/shared/ui/navigation/DesktopRefreshLabel";

interface DesktopSectionToolbarProps {
  activeDestination?: "archive" | "history";
  ariaLabel: string;
  isFetching?: boolean;
  onRefresh?: () => void;
  onScrollToBottom: () => void;
  onScrollToTop: () => void;
  onSettingsClick: React.MouseEventHandler<HTMLAnchorElement>;
  onToggleSidebar: () => void;
  secondaryAriaLabel: string;
}

/** 一覧系PC画面で共通する、履歴ツールバー由来の基本ナビゲーション。 */
export function DesktopSectionToolbar({
  activeDestination,
  ariaLabel,
  isFetching,
  onRefresh,
  onScrollToBottom,
  onScrollToTop,
  onSettingsClick,
  onToggleSidebar,
  secondaryAriaLabel,
}: DesktopSectionToolbarProps): React.ReactElement {
  return (
    <nav className="desktop-catalog-toolbar" aria-label={ariaLabel}>
      <fieldset
        className="desktop-catalog-toolbar-navigation"
        aria-label="ページ内移動"
      >
        <button
          className="desktop-catalog-toolbar-icon"
          type="button"
          onClick={onToggleSidebar}
          aria-label="履歴サイドバーを切り替える"
        >
          <FiSidebar aria-hidden="true" />
        </button>
        <button
          className="desktop-catalog-toolbar-icon"
          type="button"
          onClick={onScrollToTop}
          aria-label="ページ上部へ移動"
        >
          <FiChevronUp aria-hidden="true" />
        </button>
        <button
          className="desktop-catalog-toolbar-icon"
          type="button"
          onClick={onScrollToBottom}
          aria-label="ページ下部へ移動"
        >
          <FiChevronDown aria-hidden="true" />
        </button>
      </fieldset>

      <fieldset
        className="desktop-catalog-toolbar-primary"
        aria-label="カタログ表示"
      >
        <a
          className="desktop-catalog-toolbar-link"
          href={boardPublicPath("/board")}
        >
          <FiList aria-hidden="true" />
          リスト
        </a>
        <a className="desktop-catalog-toolbar-link" href={boardPublicPath("/")}>
          <FiGrid aria-hidden="true" />
          カタログ
        </a>
      </fieldset>

      <fieldset
        className="desktop-catalog-toolbar-secondary"
        aria-label={secondaryAriaLabel}
      >
        <a
          className="desktop-catalog-toolbar-link"
          href={boardPublicPath("/history/viewed")}
          aria-current={activeDestination === "history" ? "page" : undefined}
        >
          <FiClock aria-hidden="true" />
          履歴
        </a>
        <a
          className="desktop-catalog-toolbar-link"
          href={boardPublicPath("/archive")}
          aria-current={activeDestination === "archive" ? "page" : undefined}
        >
          <FiArchive aria-hidden="true" />
          過去ログ
        </a>
        <a
          className="desktop-catalog-toolbar-link"
          href={boardPublicPath("/settings")}
          onClick={onSettingsClick}
        >
          <FiSettings aria-hidden="true" />
          設定
        </a>
        {onRefresh && (
          <button
            className="desktop-catalog-toolbar-action desktop-catalog-toolbar-refresh"
            type="button"
            disabled={isFetching}
            onClick={onRefresh}
          >
            <DesktopRefreshLabel isFetching={Boolean(isFetching)} />
          </button>
        )}
      </fieldset>
    </nav>
  );
}
